import { ResponseMessageWithInternalStatus } from "../dto/response-message-with-internal-status.dto";

export interface TipoComprobante {
  id: number;
  denominacion: string;
  letra: string;
  codigoAfip: string;
}

export interface TipoComprobantes {
    tipoComprobantes: TipoComprobante[];
}

export interface ObtenerListadoTipoComprobanteResponse extends ResponseMessageWithInternalStatus{
 tiposComprobante: {
  id: number;
  denominacion: string;
  letra: string;
  codigoAfip: string;
 }[]
}

export interface TipoComprobantesState {
  tipoComprobantes: TipoComprobante[];
  error: boolean;
  debugMessage?: any;
}

export const initialTipoComprobantesState: TipoComprobantesState = {
  tipoComprobantes: [],
  error: false,
  debugMessage: null
};